<script>
  export default {
    name: 'HimekuriOver'
  }
</script>

<template lang="pug">
  .himekuri-over
    .himekuri-over__heading
      |参加期間は終了しました
    .himekuri-over__text
      |たくさんのご参加、
      br.brNoto
      |ありがとうございました！
</template>

<style lang="scss">
  .himekuri-over {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    &__heading {
      margin-bottom: 10px;
      color: $primary-color;
      @include fontSize(20);
      font-weight: 700;
    }
    &__text {
      line-height: (22 / 16);
      @include fontSize(16);
    }
  }
</style>
